export default __webpack_public_path__ + "static/media/ColorAndContrast_Insight.d536287c.png";